// pages/products/signage/RoadSign.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import {
  InfoSection,
  TypeBlock
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const RoadSign = () => {

  const typeGroups1 = [
    {
      title: '규격',
      items: [
        { src: '/images/products/signage/road-sign-support.webp',},
      ],
    },
    {
      title: '실제 설치사진',
      items: [
        { src: '/images/products/signage/road-sign-support1.webp', label: '단주식 표지판' },
        { src: '/images/products/signage/road-sign-support2.webp', label: '복주식 표지판' },
        { src: '/images/products/signage/road-sign-support3.webp', label: '편지식 표지판' },
        { src: '/images/products/signage/road-sign-support4.webp', label: '현수식 표지판' },
        { src: '/images/products/signage/road-sign-support5.webp', label: '문형식 표지판 - 트러스' },
        { src: '/images/products/signage/road-sign-support6.webp', label: '문형식 표지판 - 빔' },
      ],
    },
  ];

  const typeGroups2 = [
    {
      title: '비·도시지역의 도로 표지판',
      items: [
        { src: '/images/products/signage/road-sign1.webp',},
      ],
    },
    {
      title: '고속국도 표지판',
      items: [
        { src: '/images/products/signage/road-sign2.webp',},
      ],
    },
    {
      title: '도로명 표지판',
      items: [
        { src: '/images/products/signage/road-sign3.webp',},
      ],
    },
  ];

  
  return (
    <>
      <HeroSection
        title={`도로표지판`}
        subtitle={`도로이용자의 편의와 원활한 교통흐름을 위해 \n도로 표지를 제공합니다`}
        backgroundImage="/images/products/signage.webp"
        breadcrumbs={[
            { label: '홈', path: '/' },
            { label: '도로 안내표지시스템', path: '/products/signage' },
            { label: '도로표지판' }, // 현재 페이지는 path 없음
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`원활한 교통 흐름을 위한`}
        title={`도로표지판`}
        description={
          <>
            도로 이용자의 편의 증진과 원활한 교통 흐름을 위해 설치되는 필수 교통 안내 시설물로, {' '}
            <strong>경계표지, 이정표지, 방향표지, 노선표지, 안내표지</strong> 등으로 구분하여 각기 필요한 장소에 설치하고 있습니다.
            <br />
            <br />
            운전자에게 정확한 위치 정보와 진행 방향, 경로 선택, 주의사항 등을 명확하게 전달하여 {' '}
            <strong>안전한 주행 환경 조성과 교통 효율 향상</strong>에 중요한 역할을 하고 있습니다.
          </>
        }
        images={[
          '/images/products/signage2.webp',
          '/images/products/signage/signage3.jpg',
        ]}
        badgeImages={[
            "/images/logo/Nara.webp",
        ]}
      />

      <SectionDivider />

      <InfoSection>

        <InfoSection title="도로안전표지지주">
          <TypeBlock groups={typeGroups1} compact />
        </InfoSection>
        
        <InfoSection title="도로표지">
          <TypeBlock groups={typeGroups2} />
        </InfoSection>
      </InfoSection>


      <ProductDetailNav
        category="signage"
        currentPath="/products/signage/road-sign"
        listPath="/products/signage"
      />


      <CTASection />
    </>
  );
};

export default RoadSign;
